import { createAction } from '@mews/framework';

import { DistributorThunkAction } from '../../types';
import { APP_RELOADED } from './actionTypes';

export const forceReload =
    () =>
    (dispatch: $TSFixMe, _getState: $TSFixMe, { environmentService }: $TSFixMe) => {
        environmentService.invoke('location.reload');
        return dispatch(createAction(APP_RELOADED));
    };

export const getLocationHostname =
    (): DistributorThunkAction<string> =>
    (_dispatch, _getState, { environmentService, loggerService }) => {
        try {
            const location = environmentService.get('location');
            const { hostname } = location;

            return hostname;
        } catch (error) {
            loggerService.log('getHostName', 'HostName from location failed to get.', {
                error,
            });
            return '';
        }
    };
